import moment from "moment";
import { v4 } from "uuid";
import { conversation_message, arrayOfConversationMessages } from "~/schemas/schema.conversation_messages.jsx";
import {
  FETCH_CONVERSATION_MESSAGES_LOADING,
  FETCH_CONVERSATION_MESSAGES_SUCCESS,
  FETCH_CONVERSATION_MESSAGES_ERROR,
  FETCH_CONVERSATION_MESSAGE_SUCCESS,
  FETCH_CONVERSATION_MESSAGE_ERROR,
  FETCH_CONVERSATION_MESSAGE_LOADING,
  ADD_CONVERSATION_MESSAGE_LOADING,
  ADD_CONVERSATION_MESSAGE_SUCCESS,
  ADD_CONVERSATION_MESSAGE_ERROR,
  ADD_CONVERSATION_MESSAGE_FROM_EVENT_STREAM,
  DELETE_CONVERSATION_MESSAGE_LOADING,
  DELETE_CONVERSATION_MESSAGE_SUCCESS,
  DELETE_CONVERSATION_MESSAGE_ERROR,
  DELETE_CONVERSATION_MESSAGE_FROM_EVENT_STREAM_SUCCESS,
  EDIT_CONVERSATION_MESSAGE_LOADING,
  EDIT_CONVERSATION_MESSAGE_SUCCESS,
  EDIT_CONVERSATION_MESSAGE_ERROR,
  EDIT_CONVERSATION_MESSAGE_FROM_EVENT_STREAM,
  MARK_CONVERSATION_MESSAGE_AS_UNREAD_LOADING,
  MARK_CONVERSATION_MESSAGE_AS_UNREAD_SUCCESS,
  MARK_CONVERSATION_MESSAGE_AS_UNREAD_ERROR,
} from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";
import { encodeData } from "~/utils/utils.jsx";

export const fetchConversationMessages = (conversationId, cursor, lastId) => {
  const values = {
    limit: 20,
  };
  if (cursor && cursor > 0) {
    values.cursor = cursor;
  }

  if (lastId && lastId > 0) {
    values.last_id = lastId;
  }

  const query = encodeData(values);

  return {
    types: [
      FETCH_CONVERSATION_MESSAGES_LOADING,
      FETCH_CONVERSATION_MESSAGES_SUCCESS,
      FETCH_CONVERSATION_MESSAGES_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/conversations/${conversationId}/messages?${query}`,
        withHeaders: true,
      }),
    payload: {
      conversationId,
      schema: arrayOfConversationMessages,
    },
  };
};

export const fetchConversationMessage = (conversationId, id) => {
  return {
    types: [FETCH_CONVERSATION_MESSAGE_LOADING, FETCH_CONVERSATION_MESSAGE_SUCCESS, FETCH_CONVERSATION_MESSAGE_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/conversations/${conversationId}/messages/${id}`,
      }),
    payload: {
      id,
      conversationId,
      schema: {
        single: conversation_message,
      },
    },
  };
};

export const addConversationMessage = (conversationId, attributes, id = v4()) => {
  attributes.order_id = parseInt(moment().format("x"));

  return {
    types: [ADD_CONVERSATION_MESSAGE_LOADING, ADD_CONVERSATION_MESSAGE_SUCCESS, ADD_CONVERSATION_MESSAGE_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/conversations/${conversationId}/messages`,
        method: `post`,
        body: attributes,
      }),
    payload: {
      id,
      conversationId,
      attributes: {
        ...attributes,
        // for loading state of a message because we have system messages with different types of message
        class: "ActiveCollab\\Module\\System\\Model\\Message\\UserMessage",
      },
      parentType: "Conversation",
      schema: {
        single: conversation_message,
      },
    },
  };
};

export const addMessageFromEventStream = (data) => {
  return {
    type: ADD_CONVERSATION_MESSAGE_FROM_EVENT_STREAM,
    response: {
      single: data,
    },
    schema: {
      single: conversation_message,
    },
  };
};

export const deleteConversationMessage = (conversationId, id) => {
  return {
    types: [
      DELETE_CONVERSATION_MESSAGE_LOADING,
      DELETE_CONVERSATION_MESSAGE_SUCCESS,
      DELETE_CONVERSATION_MESSAGE_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/conversations/${conversationId}/messages/${id}`,
        method: `DELETE`,
      }),
    payload: {
      conversationId,
      id,
    },
  };
};

export const conversationMessageDeletedFromEventStream = (id) => {
  return {
    type: DELETE_CONVERSATION_MESSAGE_FROM_EVENT_STREAM_SUCCESS,
    id,
  };
};

export const editConversationMessage = (conversationId, id, attributes) => {
  return {
    types: [EDIT_CONVERSATION_MESSAGE_LOADING, EDIT_CONVERSATION_MESSAGE_SUCCESS, EDIT_CONVERSATION_MESSAGE_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/conversations/${conversationId}/messages/${id}`,
        method: `put`,
        body: attributes,
      }),
    payload: {
      id,
      conversationId,
      attributes,
      schema: {
        single: conversation_message,
      },
    },
  };
};

export const markConversationMessageAsUnread = (conversationId, id) => (dispatch, getState) => {
  const { conversation_messages } = getState();
  const message = conversation_messages.get(`${id}`);
  const messageCreatedOn = message?.get("created_on") || 0;

  return dispatch({
    types: [
      MARK_CONVERSATION_MESSAGE_AS_UNREAD_LOADING,
      MARK_CONVERSATION_MESSAGE_AS_UNREAD_SUCCESS,
      MARK_CONVERSATION_MESSAGE_AS_UNREAD_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/conversations/${conversationId}/messages/${id}/mark-as-unread`,
        method: `put`,
      }),
    payload: {
      conversationId,
      messageId: id,
      messageCreatedOn: messageCreatedOn > 0 ? messageCreatedOn - 1 : messageCreatedOn,
      schema: {
        single: conversation_message,
      },
    },
  });
};

export const editMessageFromEventStream = (data) => {
  return {
    type: EDIT_CONVERSATION_MESSAGE_FROM_EVENT_STREAM,
    response: {
      single: data,
    },
    schema: {
      single: conversation_message,
    },
  };
};
